module.exports = __webpack_public_path__ + "static/img/sunchunlan.0b22dc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/news/sunchunlan.jpg
// module id = NVNG
// module chunks = 1